
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
components: {XHeader},
props: ['headerTitle','histroy'],
methods:{
black(){
console.log()
if(this.histroy){
var u = navigator.userAgent
let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
if(isiOS){
console.log('苹果返回~')
window.webkit.messageHandlers.PopVCApp.postMessage('')
}else{
console.log('安卓返回~')
javascript: android.PopToApp('')
}

}else{
this.$router.back(-1)
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/header/headerBackTitle.vue